var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{staticClass:"btn-menu-new   bg-transparent",attrs:{"type":_vm.type},on:{"click":function($event){return _vm.gotoTop()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }